<div class="layout-breadcrumb-container">
  <nav class="layout-breadcrumb">
    <ol class="flex align-items-center">
      <li><i class="pi pi-home cursor-pointer" [ngStyle]="{'font-size': fontSize}" [routerLink]="'/manage-portals'"></i></li>
      <span *ngFor="let item of breadcrumb; let i = index" class="breadcrumb flex align-items-center">
        <li><i class="pi pi-angle-right pr-1" [ngStyle]="{'font-size': fontSize}"></i></li>
        <li>
            <a *ngIf="item?.url" [queryParams]="item?.queryParams" [routerLink]="item?.url"
               class="text-primary font-medium flex-nowrap non-active-breadcrumb" [ngStyle]="{'font-size': fontSize}">{{ item.label }}</a>
            <span *ngIf="!item?.url" class="font-medium text-default" [ngStyle]="{'font-size': fontSize}">{{ item.label }}</span>
        </li>
    </span>
    </ol>
  </nav>
  <div class="layout-breadcrumb-buttons" [formGroup]="formGroup">
    <div class="p-float-label my-2 w-min" *ngIf="isDropdownVisible">
      <p-dropdown (onChange)="getProductTypeListChange(breadcrumbDropdownEnum.ProductType,$event)" [filterBy]="'name'" [filter]="true" [formControlName]="'productTypeEnum'"
                  [optionLabel]="'name'" styleClass="w-min" [resetFilterOnHide]="true" [autoOptionFocus]="false"
                  [optionValue]="'id'" [options]="productTypeList" [placeholder]="'Product Type'">
        <ng-template let-product pTemplate="selectedItem">
          <div class="flex align-items-center gap-2">
            <div>{{ product?.name }}</div>
          </div>
        </ng-template>
      </p-dropdown>
      <label id="dropdown1">Product Type</label>
    </div>

    <!-- <div class="p-float-label my-2 w-16rem"  *ngIf="isManageLearMoreDropdownVisible">
      <p-dropdown (onChange)="getPageListChange(breadcrumbDropdownEnum.Page,$event)" [filterBy]="'name'" [filter]="true" [formControlName]="'page'"
                  [optionLabel]="'name'" styleClass="w-full" [resetFilterOnHide]="true" [autoOptionFocus]="false"
                  [optionValue]="'id'" [options]="pageList" [placeholder]="'Page'" [appendTo]="'body'">
        <ng-template let-Page pTemplate="selectedItem">
          <div class="flex align-items-center gap-2">
            <div>{{ Page?.name }}</div>
          </div>
        </ng-template>
      </p-dropdown>
      <label id="dropdown2">Learn More</label>
    </div> -->
<!--    <button pButton pRipple type="button" (click)="_authService.signOut()" icon="pi pi-power-off"-->
<!--            class="p-button-rounded p-button-text p-button-plain"></button>-->
  </div>
</div>
